module.exports = __webpack_public_path__ + "img/instagram_icon.66420127.png";